import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '登录',
    component: () => import('../views/login.vue'),
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    children: [{
      path: '/mail',
      name: '寄件信息',
      component: () => import('../views/mail.vue'),
    }, {
      path: '/admin',
      name: '账号管理',
      component: () => import('../views/admin.vue'),
    }, {
      path: '/receipt',
      name: '收件信息',
      component: () => import('../views/receipt.vue'),
    }, {
      path: '/orderRecord',
      name: '下单记录',
      component: () => import('../views/orderRecord.vue'),
    },{
      path:'/personnel',
      name: '人员管理',
      component: () => import('../views/personnel.vue'),
    }, {
      path: '/payMethod',
      name: '支付方式',
      component: () => import('../views/setting/payMethod.vue'),
    }, {
      path: '/deliveryMethod',
      name: '送货方式',
      component: () => import('../views/setting/deliveryMethod.vue'),
    },{
      path:'/print',
      name: '打印机',
      component: () => import('../views/setting/print.vue'),
    },{
      path:'/service',
      name: '打印机',
      component: () => import('../views/setting/service.vue'),
    },{
        path:'/bannerImage',
        name: '图片管理',
        component: () => import('../views/bannerImage.vue'),
    }]
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

export default router
